export * from "./search";
export * from "./sort";
export * from "./models";
export * from "./modifiers";

// Define a Zod schema

export const MEDIA_FILE_TYPES: (
  | "MOV"
  | "MP4"
  | "WEBM"
  | "JPG"
  | "JPEG"
  | "JFIF"
  | "PNG"
  | "GIF"
  | "BLOB"
)[] = ["MOV", "MP4", "WEBM", "JPG", "JPEG", "JFIF", "PNG", "GIF", "BLOB"];


export type StageType = 'None' | 'Details' | 'Additional Details' | 'Workflow';

export const PostCategories = [
  "Performing Arts",
  "Creative Arts",
  "Sports and Adventure",
  "Science and nature",
  "Design and making",
  "Studies and Research",
];

export interface Dict<T = any> {
  [key: string]: T;
}

